module.exports = "<div class=\"container\">\r\n  <h1>\r\n    Hospital Admin!\r\n  </h1>\r\n  <button class=\"btn btn-danger\" >Logout</button>\r\n</div>\r\n"